import { 
    Container, 
    Content,
    Title } from "./styles";
import { Column, ParagraphSection } from "components/styles";
import actionImage from "img/action_image.svg";

const GuideMessage = () => {
    return (
        <Container>
            <Content>
                <img src={actionImage} alt="Imagen de decisión"/>
                <Column  
                    width="90%"
                    justifyContent="center" 
                    align="center" 
                    gap="10px">
                    <Title textAlign="center">Recuerda:</Title>
                    <ParagraphSection>Si deseas visualizar los registros de algún recurso, <b>primero debes completar todos los filtros.</b></ParagraphSection>
                </Column>
            </Content>
        </Container>
    );
}

export default GuideMessage;